module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraBold.d45bdbc2.ttf";